module.exports = __webpack_public_path__ + "img/6.a1982492.jpg";